(() => {
  // Size the track and slides so we can translate by "one-slide width"
  function sizeTrack(slider) {
    const track  = slider.querySelector('[data-track]');
    if (!track) return 0;
    const slides = track.querySelectorAll('.tt-media-slide');
    const n = slides.length;
    if (!n) return 0;

    // Track spans all slides; each slide occupies 1/n of the track
    track.style.width = `${n * 100}%`;
    slides.forEach((s) => {
      const w = `${100 / n}%`;
      s.style.width = w;
      s.style.flex = `0 0 ${w}`;
    });

    return n;
  }

  // Move to a given slide index
  function goTo(slider, idx) {
    const track  = slider.querySelector('[data-track]');
    const slides = track?.querySelectorAll('.tt-media-slide') || [];
    const n = slides.length || 1;

    // clamp
    if (idx < 0) idx = 0;
    if (idx > n - 1) idx = n - 1;

    slider.dataset.idx = String(idx);

    // Translate the track by ONE SLIDE = (100 / n)%
    if (track) {
      const offset = -(idx * (100 / n));
      track.style.transform = `translateX(${offset}%)`;
    }

    // Update dots
    slider.querySelectorAll('.tt-dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === idx);
    });
  }

  // Bind click handlers and initial sizing
  function initSlider(slider) {
    if (!slider || slider._ttBound) return;
    const track = slider.querySelector('[data-track]');
    if (!track) return;

    const n = sizeTrack(slider);
    if (!n) return;

    slider._ttBound = true;
    const startIdx = Number(slider.dataset.idx || 0) || 0;
    goTo(slider, startIdx);

    // Click handling (prev / next / dots)
    slider.addEventListener('click', (e) => {
      const prev = e.target.closest('[data-prev]');
      const next = e.target.closest('[data-next]');
      const dot  = e.target.closest('[data-dot]');
      if (!prev && !next && !dot) return;

      let idx = Number(slider.dataset.idx || 0);

      if (prev) {
        idx = (idx - 1 + n) % n;
      } else if (next) {
        idx = (idx + 1) % n;
      } else if (dot) {
        idx = Number(dot.getAttribute('data-dot')) || 0;
      }

      goTo(slider, idx);
      e.preventDefault();
    });
  }

  function initAll(ctx = document) {
    ctx.querySelectorAll('[data-media-slider]').forEach(initSlider);
  }

  // Page load
  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
  });

  // Theme editor section loads
  document.addEventListener('shopify:section:load', (ev) => {
    initAll(ev.target);
  });

  // Keep sizing correct on resize
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-media-slider]').forEach((s) => {
      sizeTrack(s);
      goTo(s, Number(s.dataset.idx || 0) || 0);
    });
  });
})();
